import { type ElementType, type PropsWithChildren, forwardRef } from "react";
import classes from "./DDSMicroText.module.css";

export type DDSMicroTextProps = {
  as?: "span" | "p";
  className?: string;
};

export const DDSMicroText = forwardRef<HTMLElement, PropsWithChildren<DDSMicroTextProps>>(
  ({ as: tagName = "span", className, children }, ref) => {
    const Tag = tagName as ElementType;
    const classNames = [className, classes.micro].filter((c) => !!c);
    return (
      <Tag ref={ref} className={classNames.join(" ")}>
        {children}
      </Tag>
    );
  },
);

DDSMicroText.displayName = "DDSMicroText";
